module.exports = __webpack_public_path__ + "static/media/fun.38b378ad.png";